// DataContext.js
import React, { createContext, useState, useEffect } from "react";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [videos, setVideos] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://app.reciteontv.com/wp-json/wl/v2/video"
        );
        const data = await response.json();
        setData(data);
        setIsLoading(false);
      } catch (error) {
        //console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    const fetchVideos = async () => {
      try {
        const response = await fetch(
          "https://app.reciteontv.com/wp-json/wl/v1/video"
        );
        const data = await response.json();
        setVideos(data);
        setIsLoading(false);
      } catch (error) {
        //console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
    fetchVideos();
  }, []);

  return (
    <DataContext.Provider value={{ data, videos, isLoading }}>
      {children}
    </DataContext.Provider>
  );
};
